import { ErrorMessage, Field } from "formik";
import React from "react";

export default function FieldInput({ title, name, placeholder, type, min = 0 }) {
  const minDate = type === "date" ? min : "1960-01-01";
  const maxDate = type === "date" ? "2100-12-31" : undefined;

  return (
    <div className="form-group">
      <label>{title}</label>
      <Field
        type={type ? type : "text"}
        name={name}
        placeholder={placeholder}
        className="form-control"
        min={minDate}
        max={maxDate}
      />
      <ErrorMessage
        name={name}
        component="div"
        className="error"
        style={{ color: "red" }}
      />
    </div>
  );
}
